/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './Policy.scss';
import { sanitize } from 'common/services/sanitizeService';
import userTokenService from 'common/services/security/userTokenService';
import { PerformanceCookiesToggle } from './components/PerformaceCookiesToggle/PerformanceCookiesToggle';

const policyInjections = [
  {
    id: 'performance-cookies-section-header',
    child: (policy) => <PerformanceCookiesToggle policy={policy} />,
  },
];

const Policy = ({ policy }) => {
  const ref = useRef();
  const [injections, setInjections] = useState([]);
  useEffect(() => {
    const usableInjections = policyInjections
      .filter(() => policy && policy.body)
      .filter(() => ref && ref.current && ref.current.innerHTML)
      .filter(({ id }) => ref.current.innerHTML.includes(id));

    if (userTokenService.isActiveAnalyticsTerritory()) {
      setInjections(usableInjections);
    } else {
      const removeNodeSelectors = [
        '#performance-cookies-table',
        '#performance-cookies-section-header',
      ];

      removeNodeSelectors.forEach((query) => {
        const node = ref.current.querySelector(query);
        if (node && node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
    }
  }, [policy, ref]);
  return (
    <>
      <h2 className="mb-4">{policy.title}</h2>
      <div
        ref={ref}
        className="policy-container"
        dangerouslySetInnerHTML={{ __html: sanitize(policy.body) }}
      />
      {/* It is important that these come last */}
      {injections.map(({ id, child }) => {
        const parent = document.getElementById(id);
        return parent
          ? ReactDOM.createPortal(
              child(policy.body),
              parent,
              `${id}_${policy.title}`
            )
          : null;
      })}
    </>
  );
};

export default Policy;
